import jwtDecode from 'jwt-decode';

import Vue from 'vue';
// eslint-disable-next-line no-unused-vars
import router from '@/router';

import { fromUnixTime } from 'date-fns';

import { cloneDeep } from '@/helpers';
import AuthApi from '@/extensions/restricted-area/store/api/auth';
import MemberApi from '@/extensions/restricted-area/store/api/member';

// init custom validation rules
import '@/extensions/restricted-area/helpers/validate';

// initial state

const token = AuthApi.getToken();
const jwt = token ? jwtDecode(token) : {};

const state = {
    // signin: ((AuthApi.getToken() !== null)),
    member: {},
    token,
    jwt
};

// getters
const getters = {
    member: state => state.member,
    isAuthenticated: state => !!state.token,
    token: state => state.token,
    expiration: state => state.jwt.exp ? fromUnixTime(state.jwt.exp) : null,
};

// actions
const actions = {
    register({ commit }, member) {
        return AuthApi.register(member).then(({ data }) => {
            const { token } = data;
            commit('addTokenToState', token);
            commit('mapRouter', null, { root: true });
            return data;
        });
    },
    signin({ commit, dispatch }, member) {
        return AuthApi.login(member).then(({ data }) => {
            const { token } = data;
            commit('addTokenToState', token);

            Vue.nextTick(() => {
                if (!member.skipRouterMapping) commit('mapRouter', null, { root: true });
                commit('shop/setCartInitialised', false, { root: true });
                dispatch('shop/initCart', null, { root: true });
            });
            return data;
        });
    },
    refresh({ commit }) {
        return AuthApi.refreshToken().then((token) => {
            commit('addTokenToState', token);
        });
        // .catch(err => {
        //     commit('authFail')

        //     /* eslint no-console: ["error", { allow: ["error"] }] */
        //     console.error(err)
        // })
    },
    // eslint-disable-next-line no-unused-vars
    signout({ commit, dispatch }) {
        // router.push('/').finally(() => {
        //     commit('authRemove');
        //     AuthApi.removeToken();

        //     commit('mapRouter', null, { root: true });
        //     commit('shop/setCartInitialised', false, { root: true });
        //     dispatch('shop/initCart', null, { root: true });
        // });

        AuthApi.removeToken();
        Vue.nextTick(() => {
            // router.go({ path: "/", force: true })
            window.location.replace('/');
        });
    },
    fetchAuthenticatedMember({ commit, dispatch }) {
        return AuthApi.fetchAuthenticatedMember()
            .then(member => {
                commit('addMemberToState', member);
                commit('shop/setCartInitialised', false, { root: true });
                dispatch('shop/initCart', member, { root: true });
                return member;
            })
            .catch(error => {
                console.error(error);
                // commit('authRemove');
                // commit('mapRouter', null, { root: true });
                // AuthApi.removeToken();
                dispatch('signout');
            });
    },
    sendResetLinkEmail(vue, payload) {
        return AuthApi.sendResetLinkEmail(payload);
    },
    resetPassword(vue, payload) {
        return AuthApi.resetPassword(payload);
    },
    verifyEmail(vue, payload) {
        return AuthApi.verifyEmail(payload);
    },
    updateMember({ commit }, member) {
        return MemberApi.update(member).then(member => {
            commit('addMemberToState', member);
            return member;
        });
    }
};

// mutations
const mutations = {
    addTokenToState(state, token) {
        if (token !== undefined) {
            const decodedJWT = jwtDecode(token);

            state.token = token;
            state.jwt = decodedJWT;
            // state.signin = true

            AuthApi.setToken(token);
        } else {
            throw 'Authetication failed: Token undefined';
        }
    },
    addMemberToState(state, member) {
        if (member !== undefined) {
            member = cloneDeep(member);

            if (member.customer && member.customer.shoppingCart) {
                delete member.customer.shoppingCart;
            }

            state.member = member;
        } else {
            throw 'Authetication failed: Member undefined';
        }
    },
    updateMemberSettings(state, settings) {
        state.member.settings = settings;
    },
    authFail(state) {
        state.signin = false;
        AuthApi.removeToken();
    },
    // authReset (state) {
    // },
    // authForgot (state) {
    // },
    authRemove(state) {
        state.token = undefined;
        state.jwt = undefined;
        state.member = {};
    }
};

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
};
